import { createFileRoute } from '@tanstack/react-router';
import { BlConfirmPage } from '../../features/shipments';

export const Route = createFileRoute('/_public/bl-confirm/$token')({
  component: function BlConfirmRoute() {
    const { token } = Route.useParams();
    return <BlConfirmPage token={token} />;
  },
});
